module.exports = __webpack_public_path__ + "static/img/75a4dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/txgg_top.png
// module id = 609
// module chunks = 2